export const LS_AUTH_TOKEN = 'authToken'
